import React, { Suspense, lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const Billing = lazy(() => import('@pages/dashboard/Billing/index'));

export const BillingRoutes: RouteObject = {
  handle: {
    label: 'Billing',
    skipBreadCrumb: true,
  },
  children: [
    {
      path: '/dashboard/billing-history',
      handle: {
        label: 'Billing History',
      },
      element: (
        <Suspense>
          <Billing />
        </Suspense>
      ),
    },
  ],
};
